import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./styles.scss";
import photo from "../../assets/photos/UNM_HS-Wellness_Art-Walk-11_WEB.jpg";
function SectionFive({placeholderSrc,}) {


  return (

      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-1">
        <div className="tw-spacer tw-h-[6rem]"></div>
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[40%_60%] ">
          <div></div>
          <div className="tw-relative">
            <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem]">
              5
            </div>
          </div>
        </div>
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[40%_60%]">
          <div className="tw-order-2 lg:tw-order-[1]">
            <div className="">
              <div className="tw-grid tw-grid-cols-[100%] lg:tw-grid-cols-[10%_70%_20%] tw-h-[100%]">
                <div></div>
                <div className="tw-mt-1 xl:tw-mt-8 xl:tw-px-0 tw-mb-2 tw-hidden lg:tw-block"></div>
              </div>
            </div>
            <div>
              <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[10%_70%_20%] ">
                <div></div>
                <div className="tw-px-4 lg:tw-px-0 tw-grid tw-grid-cols-[90%_10%] lg:tw-grid-cols-1">
                  <div className="tw-mt-8 lg:tw-mt-0 tw-l-border-[1px] tw-border-l-[1px] tw-border-white tw-pl-3 ">
                    <p className="tw-font-bold tw-italic tw-mb-4 tw-mb-0 w-text-2xl tw-text-2xl tw-w-1/2 tw-text-2xl tw-w-1/2">
                    Cloud / Rift
                    </p>
                    <p className="tw-font-bold tw-italic tw-mb-4 tw-text-sm">
                    John Christensen
                  </p>
                    <p>
                    This monolith, one of the most recognizable works on the UNM campus, extends skyward from the open grassy area, calling to mind the meeting of earth and sky, just as so many in our HSC Community level their efforts at elevating themselves upwards in their journey at the Health Sciences Center.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-order-1 lg:tw-order-[2]">
            <LazyLoadImage
              alt="Cloud / Rift"
              src={photo} // use normal <img> attributes as props
              placeholderSrc={placeholderSrc}
            />
          </div>
        </div>
      
      </div>
  );
}
export default SectionFive;
